import { combineReducers } from "redux";
import { sampleReducer } from "./Sample.reducer";
import { newsReducer } from "./News.reducer";
import { pressReducer } from "./Press.reducer";
import { contactReducer } from "./Contact.reducer";
import { teammemberReducer } from "./TeamMember.reducer";
import { publicationReducer } from "./Publication.reducer";
import { newsletterReducer } from "./Newsletter.reducer";
import { collaboratorReducer } from "./Collaborator.reducer";
import { researchReducer } from "./Research.reducer";
import { vacancyReducer } from "./Vacancy.reducer";
import { eventReducer } from "./Event.reducer";
import { studyReducer } from "./Study.reducer";
import { bookletReducer } from "./Booklet.reducer";
import { booksReducer } from "./Books.reducer";
import { annualReportReducer } from "./AnnualReport.reducer";
import { researchArticleReducer } from "./ResearchArticle.reducer";
import { galleryReducer } from "./Gallery.reducer";
import { farmercornerReducer } from "./FarmerCorner.reducer";
import { currentResearchReducer } from "./CurrentResearch.reducer";

const rootReducer = combineReducers({
  samples: sampleReducer,
  news: newsReducer,
  press: pressReducer,
  contact: contactReducer,
  teamMember: teammemberReducer,
  publication: publicationReducer,
  newsletter: newsletterReducer,
  collaborator: collaboratorReducer,
  research: researchReducer,
  vacancy: vacancyReducer,
  event: eventReducer,
  study: studyReducer,
  booklet: bookletReducer,
  books: booksReducer,
  annualReport: annualReportReducer,
  researchArticle: researchArticleReducer,
  gallery: galleryReducer,
  farmercorner: farmercornerReducer,
  currentResearch: currentResearchReducer,
});

export default rootReducer;
